export default function (store, config) {
    if (!config)
        return;
    const by = config.by || "text";
    const dir = config.dir || "asc";
    const sort = { by, dir, ...config };
    const { tasks, activeProject } = store.getState();
    const { treeTasks } = store.getInnerState(tasks, activeProject, sort);
    store.setState({ treeTasks });
}
//# sourceMappingURL=sort.js.map